import { mockPromises } from '@/lib/mock-data/collections-data';
import type { PromiseNote } from '@/types/promise-note';

function buildMockPromiseNotes(): Record<string, PromiseNote[]> {
  const notesByPromise: Record<string, PromiseNote[]> = {};

  for (const promise of mockPromises) {
    if (!promise.notes) continue;

    notesByPromise[promise.id] = [
      {
        id: `${promise.id}-note-1`,
        promiseId: promise.id,
        content: promise.notes,
        createdAt: new Date(promise.createdAt).toISOString(),
        createdBy: {
          id: '',
          name: promise.createdBy,
        },
      },
    ];
  }

  return notesByPromise;
}

/**
 * Mock promise notes data for demo mode, derived from the seeded promises
 */
export const mockPromiseNotes: Record<string, PromiseNote[]> = buildMockPromiseNotes();

/**
 * Get notes for a specific promise
 */
export function getPromiseNotes(promiseId: string): PromiseNote[] {
  return mockPromiseNotes[promiseId] || [];
}
